export default __webpack_public_path__ + "static/media/html.7ded1f5a.svg";